import { Badge } from "@/components/ui/badge";

const STYLES = {
  "Application Received": "bg-blue-50 text-blue-700 border-blue-200",
  "Contact Attempted": "bg-amber-50 text-amber-700 border-amber-200",
  "Interview Scheduled": "bg-violet-50 text-violet-700 border-violet-200",
  Selected: "bg-emerald-600 text-white border-emerald-600",
  Rejected: "bg-red-50 text-red-700 border-red-200",
  "Not Interested": "bg-slate-100 text-slate-700 border-slate-200",
  "Future Prospect": "bg-sky-50 text-sky-700 border-sky-200",
};

export const StatusBadge = ({ status, className = "" }) => (
  <Badge
    variant="outline"
    data-testid="status-badge"
    className={`rounded-full font-medium whitespace-nowrap ${STYLES[status] || "bg-muted text-muted-foreground"} ${className}`}
  >
    {status}
  </Badge>
);
